import React, { useMemo } from 'react'
import { observer } from 'mobx-react'
import { IonModal, IonHeader } from '@ionic/react'
import Calendar from 'react-calendar'
import { cartMobx } from 'restaurant'
import { timePickMobx } from '@mobxStore'
import TimePickController from '@ctrls/timePickController'
import { Icon } from '@cps'
import { ddayjs } from '@dt/fe-utils'
import 'react-calendar/dist/Calendar.css'
import './index.scss'

interface ITimePickModalProps {
  type: 'order' | 'product';
  selectedInfo?: ITimePickInfo;
  timePickList: ITimeSelectList[];
  callback?: () => void;
  reject?: () => void;
  resolve?: () => void;
}

const TimePickModal: React.FC<ITimePickModalProps> = (props) => {
  const { type, selectedInfo, timePickList, callback, reject, resolve } = props

  const handleConfirm = (value) => {
    const pickDay = ddayjs(value).format('MM-DD')
    const pickDayIndex = timePickList.find(item => item.date === pickDay)?.dayIndex || 0
    const pickInfo = timePickList.find(item => item.dayIndex === pickDayIndex)

    TimePickController.showPicker(type, {
      info: {
        pickDayIndex,
        pickDay,
        pickTime: pickInfo?.timeList?.[0]?.timeStr,
        pickTimeRange: pickInfo?.timeList?.[0]?.pickTimeRange
      },
      callback
    })
    resolve()
  }

  const handleClose = () => {
    reject()
  }

  const minDate = useMemo(() => {
    return ddayjs().add(timePickList?.[0].dayIndex, 'day').startOf('day').valueOf()
  }, [timePickList])

  const maxDate = useMemo(() => {
    return ddayjs().add(timePickList?.[timePickList?.length - 1].dayIndex, 'day').startOf('day').valueOf()
  }, [timePickList])

  const valueDate = useMemo(() => {
    return ddayjs().add(selectedInfo?.pickDayIndex || 0, 'day').startOf('day').valueOf()
  }, [timePickList])

  return (
    <IonModal
      isOpen
      swipeToClose
      cssClass='time-pick-modal'
      onDidDismiss={handleClose}
    >
      <IonHeader>
        <div className='time-pick-header'>
          <span>{i18n.t(`newCart.${cartMobx.info.eatType}time`)}</span>
          <i className='iconfont icon-close' data-cypid='timePickModalClose' onClick={handleClose}></i>
        </div>
      </IonHeader>
      <Calendar
        className='time-pick-calendar'
        data-cypid='timePickModalPicker'
        defaultValue={new Date(valueDate)}
        minDate={new Date(minDate)}
        maxDate={new Date(maxDate)}
        prevLabel={<Icon name='chevron-left' />}
        nextLabel={<Icon name='chevron-right' />}
        showNeighboringMonth={false}
        formatDay={(locale, date) => ddayjs(date).format('DD')}
        tileDisabled={({ date }) => {
          const _date = ddayjs(date).format('MM-DD')
          if (type === 'order') {
            return !timePickMobx.timePickList?.find(item => item.date === _date)?.timeList?.length
          } else if (type === 'product') {
            return !timePickMobx.productTimePickList?.find(item => item.date === _date)?.timeList?.length
          }
        }}
        onChange={handleConfirm}
      />
    </IonModal>
  )
}

export default observer(TimePickModal)
